import request from '@request'

export function getCurTypeTrain(uid) {
  return request({
    url: '/train/list/' + uid,
    method: 'get',
  })
}

export function getAllTrainList() {
  return request({
    url: '/train/mapping',
    // url: '/sdx/mapping/train',
    method: 'get',
  })
}

export function saveTrainRecord(params) {
  return request({
    url: '/train/record',
    // url: '/sdx/train/record',
    method: 'post',
    params,
  })
}

// 获取当日训练时长
export function getDailyTrainTime() {
  return request({
    url: '/train/day/record',
    // url: '/sdx/train/day/record',
    method: 'get',
  })
}

/**
 * 获取训练记录
 */
export function getTrainRecord() {
  return request({ url: '/train/record', method: 'get' })
}

/**
 * 获取续费列表
 */
export function getRenewalList() {
  return request({ url: '/account/sdx/retail-prices', method: 'get' })
}

/**
 * 支付宝支付
 */
export function aliPay(priceId) {
  return request({
    url: '/account/payment/alipay',
    method: 'post',
    data: {
      priceId,
      source: 'sdx-web',
      payType: 'native',
    },
  })
}

/**
 * 微信支付
 */
export function wechatPay(priceId) {
  return request({
    url: '/account/payment/wxpay',
    method: 'post',
    data: {
      priceId,
      source: 'sdx-web',
      payType: 'native',
    },
  })
}

/**
 * 支付状态查询
 */
export function getPayStatus(id) {
  return request({
    url: `/account/payment${id ? '/' + id : ''}/task`,
    method: 'get',
  })
}

/**
 * 保存训练加载时间
 */
export function postLoadTime(data) {
  return request({
    url: `/train/load`,
    method: 'post',
    data: {
      trainId: data.trainId,
      startTime: data.startTime,
      endTime: data.endTime,
    },
  })
}
